/**
 * Transform booking parts into a list of refundable groups.
 * Group per type
 */
export function transformRefundableGroups(bookingParts: ApiBookingPart[], response: ApiSchema['BookingResponse']): RefundableGroup[] {
    return [
        ...transformRefundableGroupsActivity(bookingParts, response),
        ...transformRefundableGroupsAncillary(bookingParts, response),
        ...transformRefundableGroupsAccommodation(bookingParts, response),
        ...transformRefundableGroupsP2P(bookingParts, response),
    ];
}
